import {
  GetApi,
  Api
} from "../../../api/api";


const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms)); // sleep helper function

const getPublished = async (
  api: Api,
  id: string
): Promise<boolean> => {
  const fcc = await api.getFeatureCatalogCustomization(id);
  return fcc.status !== 'UnderConstruction';
}

const pollFcPublished = async (
  api: Api,
  id: string
): Promise<void> => {
  const pollPublishedTimeout = 240000; // four minutes in milliseconds
  const pollInterval = 3000; // three seconds in milliseconds

  let pollTime = 0;
  while (pollTime < pollPublishedTimeout && !(await getPublished(api, id))) {
    await sleep(pollInterval);
    pollTime = pollTime + pollInterval;
  }
  if (pollTime >= pollPublishedTimeout) {
    throw new Error("Timed out while waiting for publish of feature catalog");
  } else {
    return;
  }
}

const publishFcc = async ( id: string ) => {
  const api = await GetApi();
  const fcc = await api.getFeatureCatalogCustomization(id);
  if (fcc.version) {
    await api.publishFeatureCatalogCustomization({
      customizationId: id,
      customizationVersion: fcc.version
    })
    await pollFcPublished(api, id);
    // Here we create the next version of the feature catalog
    await api.createFeatureCatalogCustomizationVersion(id, fcc);
  } else {
    throw new Error("Cannot publish: Feature catalog missing version number.");
  }
}


export default publishFcc;